export const UPLOADING_PROCESS_STATUS = {
  SELECT_ALBUM: 'SelectAlbum',
  STARTING_UPLOAD: 'StartingUpload',
  UPLOADING: 'Uploading',
  UPLOADED_SUCCESS: 'UploadedSuccess'
};
